export default function() {
  return /^(10[0-9][0-9]|11[0-9][0-9]|12[0-9][0-9]|[2-9][0-9]{3})$/;
};